import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from '../components/common';

export default function VerifyPage() {
  const { confirmSignUp } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await confirmSignUp(email, code);
      navigate('/auth/login', { state: { verified: true } });
    } catch (err) {
      setError(err.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-bg safe-area-top safe-area-bottom">
      <div className="flex flex-col items-center justify-start min-h-screen px-4 py-12 max-w-md mx-auto">
        <div className="text-center mb-8 mt-12">
          <div className="inline-flex w-14 h-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-3" aria-hidden="true">
            <ShieldCheck size={28} />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-night-text">Verify your email</h1>
          <p className="text-sm text-gray-500 dark:text-night-muted mt-1">
            We sent a code to <strong className="text-gray-900 dark:text-night-text">{email}</strong>
          </p>
        </div>

        <div className="w-full bg-white dark:bg-night-surface rounded-2xl shadow-sm border border-gray-100 dark:border-night-card p-5 space-y-4">
          {error && (
            <div className="text-sm text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 dark:text-night-text mb-1">Verification code</span>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="000000"
                required
                maxLength={6}
                autoComplete="one-time-code"
                inputMode="numeric"
                className="w-full px-3 py-3 border border-gray-300 dark:border-night-card rounded-lg bg-white dark:bg-night-card text-center text-2xl tracking-[0.5em] font-mono text-gray-900 dark:text-night-text placeholder-gray-300 dark:placeholder-night-muted focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </label>

            <Button type="submit" disabled={loading} className="w-full">
              {loading ? 'Verifying…' : 'Verify Email'}
              {!loading && <ArrowRight size={18} aria-hidden="true" />}
            </Button>
          </form>
        </div>

        <p className="text-sm text-gray-500 dark:text-night-muted mt-6">
          <Link to="/auth/login" className="text-primary-600 dark:text-primary-400 font-medium hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
